// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout {
  display: grid;
  grid-template-columns: 20% 80%;
  color: white;
}
.admin-layout .left-nav {
  height: 100vh;
  background-color: rgb(19, 19, 19);
  color: white;
}
.admin-layout .left-nav ol {
  list-style: none;
  margin-left: 10%;
  margin-right: 10%;
}
.admin-layout .left-nav ol li {
  padding: 10px;
  transition: all 0.2s ease-in-out;
  color: white;
}
.admin-layout .left-nav ol li .left-nav-list-items {
  display: grid;
  grid-template-columns: 20% 80%;
  align-items: center;
}
.admin-layout .left-nav ol li:hover {
  border: 2px solid white;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/core/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AACF;AAAE;EACE,aAAA;EACA,iCAAA;EACA,YAAA;AAEJ;AADM;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;AAGR;AAFU;EACE,aAAA;EACA,gCAAA;EACA,YAAA;AAIZ;AAHY;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAKZ;AAHY;EACE,uBAAA;EACA,eAAA;AAKd","sourcesContent":[".admin-layout{\n  display: grid;\n  grid-template-columns: 20% 80%;\n  color: white;\n  .left-nav {\n    height: 100vh;\n    background-color: rgb(19,19,19);\n    color: white;\n      ol{\n        list-style: none;\n        margin-left: 10%;\n        margin-right: 10%;\n          li{\n            padding: 10px;\n            transition: all 0.2s ease-in-out;\n            color: white;\n            .left-nav-list-items {\n            display: grid;\n            grid-template-columns: 20% 80%;\n            align-items: center;\n          }\n            &:hover{\n              border: 2px solid white;\n              cursor: pointer;\n            }\n          }\n      }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
